import React, { useState } from 'react';

export default function EmojiCrew() {
  const [message, setMessage] = useState("Hello World!");

  return (
    <main>
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Carousel Advertising restream</h2>
        <h2>Product features</h2>
        <h2>Pricing</h2>
        <h2>Faq</h2>
      </div>
    </main>
  );
}
